import { store } from "./firebase";

/*

    Logs

*/
let unixTimestamp = () => String(new Date().getTime());

//Delete
export const del = (cUID, doc) => {
  store
    .collection(`clients/${cUID}/logs/`)
    .doc(`${doc}`)
    .delete()
    .then(() => console.log(`Deleted log ${doc}`))
    .catch(err => console.log(`${err}`));
};

//Log
export const log = (cUID, log) => {
  const stamp = unixTimestamp();
  store
    .collection(`clients/${cUID}/logs`)
    .doc(stamp)
    .set({ ...log, timestamp: stamp });
};

//Get
export const getLogs = cUID =>
  store
    .collection(`clients/${cUID}/logs`)
    .get()
    .then(snapshot => snapshot);

export const directStore = store;

// export const watch = cUID =>
//   new Promise((res, rej) => {
//     let logs = [];
//     store.collection(`clients/${cUID}/logs`).onSnapshot(doc => {
//       doc.forEach((e, i) => {
//         logs.push(e.data());
//       });
//     });
//     res(logs);
//   });



// WEBPACK FOOTER //
// ./src/firebase/firestore.js